<template>
 <div class="mt-5"  v-if="shipDetails">
        <v-card class="p-4" rounded="3">
          <div class="d-flex flex-wrap justify-space-between">
            <div>
               <h6 style="font-size: 18px; font-weight: 700">Your Shipment</h6>
            </div>
           
 <div @click="toggleView('quoteform'),this.shipDetails=false,this.userDetails=false">
                   <a
                href="#"
                style="text-decoration: underline !important;cursor: pointer;color: navy;"
              >EDIT</a
            >
                </div>
          </div>

          <div>
            <div class="row">
              <div class="ship">
                <span class="ship-title">From:</span>

                <span class="ship-subtitle">
                  {{ this.formTotalData.fromPostal }},</span
                >

                {{ this.formTotalData.fromCountry }}
              </div>
            </div>
            <div class="row">
              <div class="ship">
                <span class="ship-title"> To:</span>
                <span class="ship-subtitle">
                  {{ this.formTotalData.toPostal }},
                  {{ this.formTotalData.toCountry }}</span
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="ship">
                <span class="ship-title">Shipment Date:</span>
                <span class="ship-subtitle">
                  {{ dataChange(this.formTotalData.shipDate) }}
                </span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="ship text-end">
                <span class="ship-title">Item Type: </span>
                <span class="ship-subtitle">
                  {{ this.formTotalData.itemtype }}</span
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div>
              <div
                class="ship "
                v-for="data of this.formTotalData.items"
                :key="data"
              >

               <div class="row">
                <div class="col-md-8">
                  <span class="ship-title">Package List and Dimensions:</span>
                  <span class="ship-subtitle">
                    {{ data.weight }} KG / {{ data.length }}cm  x
                    {{ data.height }}cm x {{ data.width }}cm x
                    {{ data.quantity }} Box
                  </span>
                </div>

            <div class="col-md-4">
               <span class="chrgeble-title">Chargeable Weight :</span>
                  <span class="chrgeble-subtitle">
                    {{ convertWeight(data) }} Kg
                  </span>
            </div>

               </div>
             


                
               
              </div>
            </div>
          </div>
        </v-card>
      </div>
<div class="mt-3" v-if="userDetails ">

  <v-card class="p-3" rounded="3">
  
     <div class="d-flex flex-wrap justify-space-between">
            <div>
                 <h5 style="font-size: 18px; font-weight: 700;">User Details</h5>
            </div>
           
 <div @click="edituserDetails()">
                   <a
                href="#"
                style="text-decoration: underline !important;cursor: pointer;color: navy;"
              >EDIT</a
            >
                </div>
          </div>
    <div>
      <div class="d-flex flex-wrap pb-1 gap-1">
       <div class="ship-title">
         Name:
       </div>


       <div class="ship-subtitle">{{passDetails?.Name}}</div>
      </div>
<div class="d-flex flex-wrap pb-1 gap-1">
       <div class="ship-title">
        Email:
       </div>
       <div class="ship-subtitle">{{ passDetails?.Email }}</div>
      </div>

      <div class="d-flex flex-wrap pb-1 gap-1">
       <div class="ship-title">
        Phonenumber:
       </div>
       <div class="ship-subtitle">{{passDetails?.Contact}}</div>
      </div>

    </div>

  </v-card>
</div>

<div v-if="quoteform" style="display: flex;
    justify-content: center;">
        <div class="form-quate"
            >
        <requestFormSmall @updateQuote="handleUpdateQuote" :formData="formTotalData" />
        </div>



      </div>

      <div v-if="popupTopDetails">
          <v-card rounded="2"  class="mt-3">
            
            <div class="p-3 row">
              <div class="d-flex justify-content-center w-100 mb-2">
                Please Login or continue as Guest to fetch the shipment quote.
              </div>
              <div class="col-sm-5">
                 <VBtn
                  block
                  class="but-color"
                  @click="toggleView('loginFormDetails')"
                >
                  LOGIN
                </VBtn>
              </div>

              <div class="col-sm-2">
                <p class="popupOr m-0">OR</p>
              </div>

              <div class="col-sm-5">
                <VBtn
                  block
                  class="but-color"
                  @click="toggleView('guestFormDetail')"
                >
                  CONTINUE AS GUEST
                </VBtn>
              </div>
            </div>
          </v-card>
      </div>

      <div v-if="guestFormDetail">
        <guestForm @updateValue="getChildValue"  @updateformValue="getFormData"
        :ediuserData="edituser" :guestDetails="passDetails"
        ></guestForm>
      </div>
      <div v-if="loginFormDetails" >
        <loginForm @updateValue="getChildValue"  :loginMsg="loginmsgTrigger"
        @updateformValue="getloginData"></loginForm>
      </div>
      <div v-if="quoteData" class="text-center mt-2">
            <span>Please Wait...
              <v-progress-circular
                  color="#1f1f45"
                  :size="18"
                  :width="2"
                  indeterminate
                ></v-progress-circular>
            </span>
          </div>

      <div v-if="formResponceData">
      <div  class="w-100">
        <div class="d-flex flex-column justify-center align-center">
          <div style="font-weight: 500; font-size:18px" class="mt-5">
            Here are the rates for your shipments: {{ dataChange(this.formTotalData.shipDate) }}
          </div>
          <VDivider style="inline-size: 85%" class="mb-5" />

          <div class="w-100">
            <v-card
              v-for="(response, index) in quoteResponse"
              :key="index"
              class="p-3"
              :class="'QuoteResponse mb-4 p-3' + index"
            >

<div class="row align-items-center">
  <div class="col-md-2">
<img
                      :src="response.CarrierLogo"
                      style="height: 60px;width:100px"
                     
                    />
  </div>
  <div class="col-md-3" style="    font-size: 14px;
    font-weight: 500;">
    {{ response.CarrierName }} - {{ response.ServiceName }}
  </div>
  
  <div class="col-md-3">
    <div  style="font-size:14px;
    font-weight: 500;">
      <v-icon size="15" color="#ed1c24">mdi-truck-delivery-outline</v-icon>
      <span class="ms-1">Delivery</span>
      <span class="ms-2">{{   momentfuncArrivalDt(response.DeliveryDate.split("T")[0]) }}</span>
      
    </div>
    
  </div>
  
  <div class="col-md-2 d-flex">
    <div  style="color:#1f1f45 ;font-size:18px;
    font-weight: 500;
;"
                  >
                    {{ response.Currency }} {{ response.FreightRate }}

  </div>
  </div>
  <div class="col-md-2">
    <VBtn
                  style="margin-top: 10px;"
                    block
                    color="#ed1c24"
                    class="booknowBtn"
                    @click="selectDelivery(response,index) "
                  >
                   
                    BOOK NOW
                  </VBtn>
  </div>

</div>


            </v-card>
          </div>

          <div class="mt-4 w-100 ">
            <h5>Are you expecting a better rate?</h5>

            <p>
              Please share your target rate. Our quote tesk will getback to you
              special spot rate.
            </p>

            <div class="row mt-2">
              <div class="col-md-4 carrer">
                <label>CARRIER</label>
                <v-select
                  v-model="carrierquote"
                  :items="['DHL', 'FedEx', 'Aramex', 'UPS', 'Others']"
                  variant="outlined"
                ></v-select>
              </div>
              <div class="col-md-4">
                <label>TARGET QUOTE</label>
                <v-text-field
                  variant="outlined"
                  v-model="targequote"
                  :rules="targequoterule"
                  :maxlength="5"
                ></v-text-field>
              </div>
              <div class="col-md-4 mt-3">
                <v-btn
                  class="but-color"
                  style="width: 100%; height: 50px"
                  @click="getquoteData()"
                >
                  <VProgressCircular
                    color="white"
                    v-if="goLoader1"
                    indeterminate
                  />
                  Get Quote</v-btn
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>

      <div v-if="failedResponceData" class="mt-2">
        <v-card class="p-3 ">
     <div class="d-flex flex-wrap justify-space-between">
      <div style=" font-size: 17px;
    font-weight: 600;">
        No rates available for your shipment.
      </div>
      <div>
        <VBtn width="50%" @click="toggleView('quoteform'),this.shipDetails=false,this.userDetails=false"
                          class="but-color"
                          block
                        
                        > modify</VBtn>
        
      </div>
     </div>
        </v-card>
      </div>

<div v-if="shipperForm" class="mt-2">
  <shipperForm  @updateValue="getShipvalue"  :getFormvalue=formTotalData   />
</div>
<div v-if="pageLoader">
  <pageLoader ></pageLoader>
</div>

</template>

<script>
import axios from "axios"
import moment from "moment"
import requestFormSmall from "@/components/requestFormSmall.vue";
import guestForm from "@/components/guestForm.vue" 
import loginForm from "@/components/loginForm.vue"
import shipperForm from  "@/components/shipperForm.vue"
import pageLoader from "@/components/pageLoader.vue"
export default{
     components: {
    requestFormSmall,
    guestForm,
    loginForm,
    shipperForm,
    pageLoader,
  },
    data (){
return{

    // <---true false value satrt---->
    shipDetails:true,
    guestFormDetail:false,
   quoteform:false,
   popupTopDetails:false,
   loginFormDetails:false,
   formResponceData:false,
   failedResponceData:false,
   userDetails:false,
   shipperForm:false,
   edituser:false,
   pageLoader:true,
   quoteData: false,

// <---true false value end---->
targequote:"",
carrierquote:"",

currency: "LKR",
    shipId:"",
  formTotalData:{},
   quoteResponse: [],
   loginmsgTrigger:0,
  endpoint:"",
  passDetails:{
    Name:"Majestic",
    Email:"sales@majesticcourier.com",
    Contact:"8124243000"
  },
}
    },

    methods:{
      edituserDetails(){

this.userDetails=false
this.edituser=true
this.toggleView('guestFormDetail')
      },

selectDelivery(response,index){
  this.formTotalData.quoteselectedId = index
  this.formTotalData.quoteSelected=response
  //  this.popupTopDetails = true
  this.toggleView('popupTopDetails')
  // this.toggleView('shipperForm')
},

 getChildValue(val) {
      console.log(val,'0000')
       this.toggleView(val)
    },
getShipvalue(val) {
      console.log(val,'0000')
       this.toggleView(val)
    },
        toggleView(view){
console.log(view,'viewview')
 this.quoteform=false,
  this.popupTopDetails=false,
  this.guestFormDetail=false,
  this.loginFormDetails=false,
  this.formResponceData=false,
  this.failedResponceData=false,
  this.shipperForm=false,
 
this[view]=true
        },
 handleUpdateQuote(value) {
      console.log('Received from child:', value); 
      if(value){
         window.location.reload();
      }
    },

    momentfuncArrivalDt(date) {
      return moment(date).format("ddd Do");
    },
 convertWeight(data) {
    console.log(data ,'ioii')
  const volumetric = ((data?.length * data?.width * data?.height) / 4000) * data.quantity;
  const weight=data?.weight * data.quantity
  return volumetric < weight ? Math.ceil(weight)  : Math.ceil(volumetric) ;
},

         dataChange($event) {
      // console.log()
      return moment($event).format("DD-MMM-YYYY");
    },
         shingConvertData() {
      this.shipId = this.$route.query.quoteRequest_id;
      if (this.shipId) {
        this.step1 = false;
        this.popupTopDetails = false;
        this.openOverlay = true;

        let $data = {
          quoteProcessId: this.shipId,
        };
        axios
          .post(
            `https://connect.Majesticcourier.com/api/quoterequestdetails`,
            $data,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            this.pageLoader=false

            this.formTotalData = JSON.parse(
              response.data.quoterequestdetails.QuoteRequestData
            );
            console.log(this.formTotalData,response.data, "this.formTotalData");
            // this.popupForm()
            let data = JSON.parse(sessionStorage.getItem("quoteResponse"))
            if(data?.data?._RatesResponce.length > 0){
              this.toggleView('formResponceData')
              this.quoteResponse = data.data._RatesResponce
            }
            else {
              this.toggleView('failedResponceData')
            }
          })
          .catch((error) => {
            console.error("There was a problem with this operation:", error);
          });
      }
    },


    getFormData(value){
        this.shipId = this.$route.query.quoteRequest_id;
      console.log(value,'val')
      this.passDetails = {
          Name: value?.name || "admin",
          Email: value?.email || "",
          Contact: value?.number ||"85353788",
          QuoteProcessId: this.shipId,
        };
      // this.popupForm()
      this.toggleView('userDetails')
      this.toggleView('shipperForm')

    },
    getloginData(value){

      console.log(value,'va444l')
      this.passDetails = {
          email: value?.email || "",
          password:value?.password || "",
        };
        if(value?.username){
           this.passDetails.username=  value?.username
           const url="registerCustomer"
             this.loginRester(url)
        }
        else{
          const url="loginCustomer"
             this.loginRester(url)
        }

    

    },
     async loginRester(url) {
        this.shipId = this.$route.query.quoteRequest_id;
      if (this.shipId) {
  
        this.formTotalData.passDetails=this.passDetails
        console.log(this.passDetails, "passDetails");
        try {
          const response = await axios.post(
            `https://connect.Majesticcourier.com/api/${url}`,
            this.passDetails,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log(response, "responsevvvv");

          if(response.data.success){
        this.passDetails = {
           Name: response.data.data?.name || response.data.data?.user?.name || "John",
          Email: response.data.data?.email || response.data.data?.user?.email || "admin@gmail.com",
          Contact:response.data. data?.number ||"85353788",
          QuoteProcessId: this.shipId,
        };
        // this.popupForm()
        this.toggleView('userDetails')
        this.toggleView('shipperForm')
          }
         
        } catch (error) {
            console.error("There was a problem with the fetch operation:", error);
          if(!error.response.data.success && url=="loginCustomer"){
         
           this.loginFormDetails=true
            this.loginmsgTrigger++
          }
        
        }
      } 
    

    
    },






 async popupForm() {
    this.shipId = this.$route.query.quoteRequest_id;
    this.quoteData = true;
      if (this.shipId) {

 sessionStorage.setItem("userInfo", JSON.stringify(this.passDetails));

        console.log(this.formTotalData,'formTotalDataformTotalData')
        // this.formTotalData.passDetails=this.passDetails
        this.formTotalData.quoteId = Math.floor(100000 + Math.random() * 900000);
        this.formTotalData.fromPostal = this.formTotalData.fromPostal.split("-")[0].trim().split(" ")[0];
        this.formTotalData.toPostal = this.formTotalData.toPostal.split("-")[0].trim().split(" ")[0];
        this.passDetails.QuoteProcessId = this.shipId
        console.log(this.passDetails, "passDetails");
        try {
          const response = await axios.post(
            `https://connect.Majesticcourier.com/api/getquote2`,
            //`https://connect.Majesticcourier.com/api/cachePopupformdata`,
            this.formTotalData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          console.log(response, "responsevvvv");
          if (response.data.QuoteResponse2.data._RatesResponce.length > 0) {
          this.quoteData = false;
          this.toggleView('formResponceData')
          // this.userDetails=true,
             this.quoteResponse = response.data.QuoteResponse2.data._RatesResponce;
          console.log(
            response.data.QuoteResponse2.data._RatesResponce,
            "response.data._RatesResponce"
          );
          }
          else{
             this.toggleView('failedResponceData')
            //  this.userDetails=true
            this.quoteData = false;
          }
        } catch (error) {
          this.toggleView('failedResponceData')
          this.quoteData = false;
          // this.userDetails=true
          console.log("There was a problem with the fetch operation:",error);
        }
      } 
    

    
    },

    },
    created(){
this.endpoint=localStorage.getItem("endpoint")

    this.shingConvertData();
    // this.popupForm()
    const user = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
    console.log(user,'user')
    if(user.Email && user.Name){
    
     this.passDetails=user 
     this.popupTopDetails=false
    //  this.userDetails=true
    }

    this.quoteId = Math.ceil(Math.random() * 1000000);
    console.log("Math.ceil(Math.random() * 1000000)", this.quoteId);
    //this.currency = sessionStorage.getItem('portalCurrency')
    }

}

</script>

<style scoped>
/* @import "@/assets/formResponce.css"; */

>>>.v-field__field {
    height: 35px;}

   >>> .carrer .v-select .v-select__selection-text {
    position: relative !important;
    top: -20px !important
  }

  @media screen and (max-width:660px) {
.v-field--center-affix .v-field__prepend-inner {
    padding-top: 12px !important;
}
.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
   background: none !important;
       POSITION: relative !important;

}
.postal-form .v-field__input {
    top: -2px !important;
}
.v-input__control {
    display: flex;
    grid-area: control;
    height: 40px;
}
}
>>>.v-field--center-affix .v-field__prepend-inner {
    padding-top: 12px !important;
}
>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
   background: none !important;
       POSITION: relative !important;

}
>>>.postal-form .v-field__input {
    top: -2px !important;
}
>>>.v-input__control {
    display: flex;
    grid-area: control;
    height: 40px;
}
>>>.v-field--focused .v-field__prepend-inner, .v-field--focused .v-field__append-inner {
    opacity: 1;
    height: 40px !important;
}
>>>.v-field--center-affix .v-field__prepend-inner {
    align-items: center;
    padding-top: 0 !important;
    height: 40px;
}
>>>.v-autocomplete--single:not(.v-autocomplete--selection-slot) .v-field--focused .v-autocomplete__selection {
    opacity: 0;
    display: none !important;
}
</style>